import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import GlassCard from './GlassCard';

const {
  FiActivity,
  FiFileText,
  FiHeart,
  FiPhone,
  FiShield
} = FiIcons;

const Footer = () => {
  const links = [
    ['How It Works', '/how-it-works'],
    ['About', '/about'],
    ['Medical, Privacy & Legal Notice', '/disclaimer']
  ];

  const contacts = [
    ['Emergency', '000', 'text-red-400'],
    ['Lifeline', '13 11 14', 'text-yellow-400'],
    ['healthdirect', '1800 022 222', 'text-blue-400']
  ];

  return (
    <footer className="relative z-10 mt-12 sm:mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8">
        <GlassCard className="overflow-hidden" hover={false}>
          <div className="p-5 sm:p-8 grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center space-x-3 mb-4">
                <SafeIcon icon={FiActivity} className="h-8 w-8 text-green-400" />
                <div>
                  <p className="text-xl font-bold text-green-400 terminal-text">
                    MedExplainGPT
                  </p>
                  <p className="text-xs text-green-300">Australia 🇦🇺</p>
                </div>
              </Link>
              <p className="text-sm text-green-100">
                Automated educational explanations of medical-report text. Not medical
                advice and not a substitute for a healthcare professional.
              </p>
            </div>

            <div>
              <h3 className="text-white font-semibold mb-4 flex items-center">
                <SafeIcon icon={FiFileText} className="mr-2 text-green-400" />
                Resources
              </h3>
              <div className="space-y-3">
                {links.map(([label, path]) => (
                  <Link
                    key={path}
                    to={path}
                    className="block text-sm text-green-200 hover:text-green-300"
                  >
                    {label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-white font-semibold mb-4 flex items-center">
                <SafeIcon icon={FiPhone} className="mr-2 text-red-400" />
                Australian support
              </h3>
              <div className="space-y-3">
                {contacts.map(([service, number, color]) => (
                  <div key={service}>
                    <p className="text-xs text-green-300">{service}</p>
                    <a
                      href={`tel:${number.replace(/\s/g, '')}`}
                      className={`font-bold ${color}`}
                    >
                      {number}
                    </a>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-white font-semibold mb-4 flex items-center">
                <SafeIcon icon={FiShield} className="mr-2 text-green-400" />
                Processing summary
              </h3>
              <div className="space-y-3 text-sm text-green-100">
                <p>Reports are not saved to an application database.</p>
                <p>Extracted report text is sent to OpenAI.</p>
                <p>API keys are kept in browser session storage.</p>
              </div>
            </div>
          </div>

          <div className="border-t border-green-500/20 px-5 py-5 flex flex-col sm:flex-row justify-between items-center gap-3">
            <p className="text-sm text-green-200">
              © 2025 Ai8848. All rights reserved.
            </p>
            <p className="text-xs text-green-300 flex items-center">
              Made with
              <SafeIcon icon={FiHeart} className="h-4 w-4 text-red-400 mx-2" />
              for clearer health conversations
            </p>
          </div>

          <motion.div
            className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-green-400/60 to-transparent"
            animate={{ x: ['-100%', '100%'] }}
            transition={{ duration: 4, repeat: Infinity, repeatDelay: 3 }}
          />
        </GlassCard>
      </div>
    </footer>
  );
};

export default Footer;